import { Tool02, X } from '@untitled-ui/icons-react';

import { cn } from '@/utils/cn';

interface CriticalAlertProps {
  id: number;
  title: string;
  message: string;
  onClose: (id: number) => void;
}

const CriticalAlert = ({ id, title, message, onClose }: CriticalAlertProps) => {
  const handleCloseBtnClick = () => {
    onClose(id);
  };

  return (
    <div className={cn('min-h-16 py-4 gap-4 rounded-[12px] bg-[#F59014] px-3 flex md:items-center justify-between')}>
      <Tool02 className="text-gray-10 w-6 h-6" />
      <div className="flex md:flex-row flex-col gap-2 flex-1">
        <span className="font-semibold text-left text-base text-gray-10">{title}</span>
        <span className="font-normal text-left flex-1 text-base text-[#595959]">{message}</span>
      </div>
      <X className="h-6 w-6 text-white cursor-pointer" onClick={handleCloseBtnClick} />
    </div>
  );
};

export default CriticalAlert;
